// extracted by mini-css-extract-plugin
module.exports = {"tab":"AsideTab_tab__BAMSU"};